{
    "ModalTitleStatusChange": "Login do Agente ACD",
    "LocationStatusTitle": "Localização",
    "LocationStatusDescription": "Escolha um dispositivo e um agente ACD para entrar.",
    "StatusOptionsTitle": "Opções",
    "AcdGroupOptionsDescription": "Se o servidor telefônico de destino suportar, você pode escolher o grupo de ACDs para o qual o status de ACD selecionado será alterado especificamente.",
    "AcdGroupLabel": "Grupo ACD",
    "AcdAgentLabel": "Agente ACD",
    "FooterButtonOk": "OK",
    "FooterButtonCancel": "Cancelar",
    "FooterButtonHelp": "Ajuda",
    "StatusChange_PromptMessage": "Todas as configurações serão perdidas ao fechar. Tem certeza de que deseja fechar esta janela?",
    "StatusChange_PromptConfirm": "sim",
    "StatusChange_PromptCancel": "Cancelar",
    "StatusChange_DevicesLabel": "Dispositivo",
    "NAME": "StatusChange"
}